import { useEffect } from 'react'
import type { RefObject } from 'react'
import { useLatest } from './useLatest.ts'

export type DismissReason = 'outside' | 'escape'

/** While `open`, a mousedown outside `ref` or Escape anywhere calls `onClose`. */
export const useDismissable = (ref: RefObject<HTMLElement | null>, open: boolean, onClose: (reason: DismissReason) => void) => {
  const close = useLatest(onClose)
  useEffect(() => {
    if (!open) {
      return
    }
    const outside = (event: MouseEvent) => {
      if (!ref.current?.contains(event.target as Node)) {
        close.current('outside')
      }
    }
    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        close.current('escape')
      }
    }
    document.addEventListener('mousedown', outside)
    document.addEventListener('keydown', escape)
    return () => {
      document.removeEventListener('mousedown', outside)
      document.removeEventListener('keydown', escape)
    }
  }, [open, ref, close])
}
